export default __webpack_public_path__ + "static/media/bg01.fca1b3eb.png";